<!-- 游戏分类 -->
<template>
  <section ref="classifyComponent" class="Classify-Component">
    <div class="classify__title">
      <h2>{{ $t('lang039') }}</h2>
      <nuxt-link class="classify__more-btn" :to="localePath('/classify')">
        <div>
          {{ $t('lang040') }}
        </div>
        <div class="arrow-icon"></div>
      </nuxt-link>
    </div>
    <div class="classify__content">
      <ul
        class="classify__list"
        :style="{ height: responsive ? `${classifyItemH}px` : '273px' }"
      >
        <li
          v-for="(item, index) in classifyDataArr"
          :key="index"
          :style="classifyItemWH"
        >
          <nuxt-link
            :to="
              localePath(
                '/games/' + item.title.replace(/\s/g, '-').replace(/\'/g, '_')
              )
            "
          >
            <img
              v-lazy="item.reserve[0].value"
              :title="item.title"
              :alt="item.title"
            />
            <span class="classify__name">{{ item.title }}</span>
          </nuxt-link>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { throttle } from 'throttle-debounce';

export default {
  props: {
    // 是否随窗口大小改变尺寸
    responsive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    this.throttleResize = throttle(500, this.resize);
    return {
      classifyItemW: 0,
      classifyItemH: 0
    };
  },
  computed: {
    classifyDataArr() {
      const { gameClassifyList } = this.$store.state;
      return gameClassifyList.slice(0, 7);
    },
    classifyItemWH() {
      const { responsive, classifyItemW, classifyItemH } = this;
      if (responsive) {
        return {
          width: `${classifyItemW - 20}px`,
          height: `${classifyItemH}px`
        };
      }
      return {};
    }
  },
  mounted() {
    if (this.responsive) {
      window.addEventListener('resize', this.throttleResize);
      this.resize();
    }
  },
  beforeDestroy() {
    if (this.responsive) {
      window.removeEventListener('resize', this.throttleResize);
    }
  },
  methods: {
    resize() {
      const classifyWrapper = this.$refs.classifyComponent;
      const classifyWrapperW = classifyWrapper.clientWidth;
      const classifyItemW =
        classifyWrapperW / Math.floor(classifyWrapperW / 200);
      const classifyItemH = (Math.floor(classifyItemW - 20) * 242) / 174 + 40;
      this.classifyItemW = classifyItemW;
      this.classifyItemH = classifyItemH;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/mixin.scss';

.classify__title {
  height: 35px;
  margin-bottom: 14px;

  h2 {
    display: inline-block;
    margin-right: 30px;
    vertical-align: middle;
    font-size: 28px;
    font-weight: 600;
    color: #2f3033;
    line-height: 40px;
  }

  .classify__more-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    font-weight: 400;
    color: #8a8f99;
    line-height: 16px;
    position: relative;
    top: 9px;
    float: right;

    .arrow-icon {
      width: 12px;
      height: 12px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      background-image: url('~@assets/img/right_arrow.png');
    }
  }
}

.classify__content {
  overflow: hidden;
  margin-right: -25px;

  ul {
    overflow: hidden;

    li {
      width: 171px;
      height: 271.81px;
      float: left;
      margin-right: 24px;
      margin-bottom: 2px;
      overflow: hidden;

      &:last-child {
        margin-right: 0;
      }

      a,
      img {
        display: block;
        width: 100%;
        color: #3a5161;
      }

      a:hover {
        color: #0dc;
      }

      img {
        background: #e4e4e4;
        border-radius: 4px;
        width: 171px;
        height: 237.81px;
        object-fit: cover;
        object-position: top;
      }

      .classify__name {
        display: inline-block;
        width: 100%;
        padding-top: 10px;
        padding-bottom: 2px;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #2f3033;
        line-height: 19px;

        @include els();
      }
    }
  }
}
</style>
